import { combineReducers, createStore } from 'redux';
import * as reducers from './reducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
/**
 * Simple Redux
 */
/*
 export default createStore(combineReducers(reducers), composeWithDevTools());
 */

/**
 * Redux-Persist
 */
const persistedReducer = persistReducer(
    { key: 'root', storage: storage },
    combineReducers(reducers),
);
const storeFn = () => {
    let store = createStore(persistedReducer, composeWithDevTools());
    // @ts-ignore
    let persistor = persistStore(store);
    return { store, persistor };
};

export const { store, persistor } = storeFn();

export default { store, persistor };
